var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-divider',{staticClass:"divider row visible-on col-xs-3 col-sm-2 col-md-1 col-lg-1 col-xs-offset-5 col-sm-offset-5 col-md-offset-5 col-lg-offset-5"})
}
var staticRenderFns = []

export { render, staticRenderFns }